{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-7-deutsch-satzstrukturen-adverbialsaetze-kommasetzung",
  "version": "2026.08.1",
  "title": "Deutsch 7: Komplexe Syntax – Satzreihe, Satzgefüge, Adverbialsätze und Zeichensetzung (Realschule 7 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Deutsch 7: Satzreihe (Parataxe) vs. Satzgefüge (Hypotaxe), 6 Typen von Adverbialsätzen (Kausal, Temporal, Konditional etc.), Relativsätze, Infinitivgruppen und das/dass-Regeln.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T23:10:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/7/deutsch",
      "checked": "2026-08-15",
      "label": "Realschule Deutsch 7, Lernbereich Sprache untersuchen und Richtig schreiben"
    }
  ],
  "atoms": [
    {
      "id": "01K4D7S0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4D7S0000000000000000A01",
      "namespace": "deutsch-grammatik",
      "slug": "satzreihe-vs-satzgefuege-hauptsatz-nebensatz-verbposition",
      "title": "Satzbaulehre: Satzreihe (Parataxe) vs. Satzgefüge (Hypotaxe) und Verbendstellung im Nebensatz",
      "domain": "schule/deutsch/grammatik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q188",
          "target_label": "Clause",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "deutsch",
          "topic_code": "lb3",
          "topic_title": "Sprachstrukturen und Grammatik",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "deutsch",
          "topic_code": "lb3",
          "topic_title": "Sprachstrukturen und Grammatik",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D7S0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "An welcher Position steht das finite (gebeugte) Verb verbindlich in einem eingeleiteten deutschen Nebensatz (Gliedsatz)?",
          "concept": "Ganz am Ende des Nebensatzes (Verbendstellung, z. B. '..., weil es heute regnet.')",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Ganz am Ende des Nebensatzes (Verbendstellung)",
              "An zweiter Position wie im Hauptsatz"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D7S0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Unterscheide Satzreihe (Parataxe: Verbindung von mindestens 2 gleichberechtigten Hauptsätzen [HS + HS], finite Verben an 2. Stelle, nebenordnende Konjunktionen wie *und, oder, aber, denn, sondern*) von Satzgefüge (Hypotaxe: hierarchische Verknüpfung aus mindestens einem übergeordneten Hauptsatz und einem untergeordneten Nebensatz [HS + NS], finite Verben im NS ganz am Ende, unterordnende Konjunktionen wie *weil, dass, obwohl, nachdem*), analysiere die Kommasetzung und bestimme die Satzstrukturen in: a) 'Die Sonne schien hell, aber ein kalter Wind wehte über die Felder.' b) 'Weil der Zug Verspätung hatte, kamen wir zu spät zum Konzert.'",
          "concept": "Satzreihe (HS + HS): Nebenordnung, Verb 2. Position; Satzgefüge (HS + NS): Unterordnung, NS mit Verbendstellung; a) Satzreihe (zwei Hauptsätze mit nebenordnendem 'aber'); b) Satzgefüge (untergeordneter Kausalsatz 'Weil...' gefolgt vom Hauptsatz 'kamen wir...').",
          "sample_solution": "1. Der grammatische Unterschied: Satzreihe vs. Satzgefüge: - **1. Die Satzreihe (Parataxe / Hauptsatzreihe)**:   * Verbindung von **mindestens zwei gleichwertigen, selbstständigen Hauptsätzen (HS + HS)**.   * In jedem Teilsatz steht das **finite Verb an 2. Satzposition (Kernsatzstellung)**.   * Teilsätze werden durch ein **Komma** getrennt, es sei denn, sie sind durch die Konjunktionen *und* bzw. *oder* verbunden.   * **Nebenordnende Konjunktionen**: *und, oder, aber, denn, sondern, doch* (Merkwort: ADUSO). - **2. Das Satzgefüge (Hypotaxe)**:   * Verbindung aus **mindestens einem übergeordneten Hauptsatz (HS)** und **einem oder mehreren untergeordneten Nebensätzen (NS / Gliedsätzen)**.   * Ein Nebensatz kann nicht alleine stehen; er ist grammatisch vom Hauptsatz abhängig.   * **Das unfehlbare Erkennungsmerkmal**: Im Nebensatz steht das **finite Verb immer an allerletzter Stelle (Verbendstellung)** (*'... weil er den Bus **verpasst hat**'*).   * Nebensätze werden durch ein **Komma** vom Hauptsatz abgetrennt (egal ob der NS voransteht, nachgestellt oder eingeschoben ist). 2. Satzstrukturanalyse der Beispiele: - **a) 'Die Sonne schien [2. Stelle] hell, aber ein kalter Wind wehte [2. Stelle] über die Felder.'**   * Struktur: **Satzreihe (HS + HS)**.   * Begründung: Beide Teilsätze sind eigenständige Hauptsätze mit dem finiten Verb an zweiter Stelle, verbunden durch die nebenordnende Konjunktion *aber*. - **b) 'Weil der Zug Verspätung hatte [Ende], kamen [1. Stelle] wir zu spät zum Konzert.'**   * Struktur: **Satzgefüge (NS + HS)**.   * Begründung: Der 1. Satz ist ein untergeordneter Nebensatz mit einleitender Subjunktion *Weil* und dem Verb *hatte* ganz am Satzende; der 2. Satz ist der Hauptsatz."
        }
      ]
    },
    {
      "id": "01K4D7S0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4D7S0000000000000000A02",
      "namespace": "deutsch-grammatik",
      "slug": "adverbialsaetze-kausal-temporal-konditional-konsekutiv",
      "title": "Adverbialsätze und Konjunktionen: Die 6 Sinnesrichtungen (Kausal, Temporal, Konditional, Konsekutiv, Final, Konzessiv)",
      "domain": "schule/deutsch/grammatik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4D7S0000000000000000A01",
          "type": "hard",
          "rationale": "Adverbialsätze sind semantisch spezialisierte Nebensätze im Satzgefüge."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q188",
          "target_label": "Adverbial clause",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "deutsch",
          "topic_code": "lb3",
          "topic_title": "Sprachstrukturen und Grammatik",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "deutsch",
          "topic_code": "lb3",
          "topic_title": "Sprachstrukturen und Grammatik",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D7S0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welcher Typ von Adverbialsatz wird durch die Konjunktionen 'obwohl', 'obgleich' oder 'obschon' eingeleitet und drückt einen unzureichenden Gegengrund aus?",
          "concept": "Der Konzessivsatz (Einräumungssatz)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Der Konzessivsatz (Einräumungssatz)",
              "Der Kausalsatz (Begründungssatz)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D7S0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Systematisiere die 6 wichtigsten Adverbialsatz-Typen der deutschen Grammatik nach Sinnrichtung, Fragewort und typischen Konjunktionen: 1. **Temporalsatz (Zeit)**: Wann?, *als, während, nachdem, bevor, seit*, 2. **Kausalsatz (Grund)**: Warum?, *weil, da*, 3. **Konditionalsatz (Bedingung)**: Unter welcher Bedingung?, *wenn, falls, sofern*, 4. **Konsekutivsatz (Folge)**: Mit welcher Folge?, *sodass, so dass, dass*, 5. **Finalsatz (Absicht/Zweck)**: Wozu?, *damit, um ... zu*, 6. **Konzessivsatz (Einräumung)**: Trotz welchen Umstands?, *obwohl, wenn auch* und bestimme die Typen in: a) 'Er trainiert täglich, damit er den Marathon gewinnt.' b) 'Obwohl es in Strömen goss, gingen wir wandern.' c) 'Nachdem wir gegessen hatten, machten wir die Hausaufgaben.'",
          "concept": "6 Adverbialsatz-Arten; a) Finalsatz (Wozu? -> damit); b) Konzessivsatz (Trotz was? -> obwohl); c) Temporalsatz (Wann? -> nachdem mit Vorzeitigkeit).",
          "sample_solution": "1. Die 6 Haupttypen der Adverbialsätze im Überblick: - **1. Temporalsatz (Zeitsatz)**:   * **Fragewörter**: *Wann?, Wie lange?, Seit wann?, Bis wann?*   * **Konjunktionen**: *als, wenn, während, nachdem, bevor, ehe, seitdem, bis, sobald*. - **2. Kausalsatz (Begründungssatz)**:   * **Fragewörter**: *Warum?, Weshalb?, Aus welchem Grund?*   * **Konjunktionen**: *weil, da*. - **3. Konditionalsatz (Bedingungssatz)**:   * **Fragewörter**: *Unter welcher Bedingung?, Wann?*   * **Konjunktionen**: *wenn, falls, sofern, vorausgesetzt dass*. - **4. Konsekutivsatz (Folgesatz)**:   * **Fragewörter**: *Mit welcher Folge?, Was folgt daraus?*   * **Konjunktionen**: *sodass, so ... dass*. - **5. Finalsatz (Absichtssatz / Zwecksatz)**:   * **Fragewörter**: *Wozu?, Mit welcher Absicht?, Zu welchem Zweck?*   * **Konjunktionen**: *damit, auf dass, um ... zu*. - **6. Konzessivsatz (Einräumungssatz)**:   * **Fragewörter**: *Trotz welchen Umstands?, Ungeachtet welcher Tatsache?*   * **Konjunktionen**: *obwohl, obgleich, obschon, wenn auch, wenngleich*. 2. Bestimmung der Beispielsätze: - **a) 'Er trainiert täglich, damit er den Marathon gewinnt.'**   * **Finalsatz (Zwecksatz)** (Frage: *Wozu trainiert er?* $\\rightarrow$ *damit er gewinnt*). - **b) 'Obwohl es in Strömen goss, gingen wir wandern.'**   * **Konzessivsatz (Einräumungssatz)** (Frage: *Trotz welchen Umstands gingen wir?* $\\rightarrow$ *obwohl es goss*). - **c) 'Nachdem wir gegessen hatten, machten wir die Hausaufgaben.'**   * **Temporalsatz (Zeitsatz der Vorzeitigkeit)** (Frage: *Wann machten wir die Hausaufgaben?* $\\rightarrow$ *nachdem wir gegessen hatten*)."
        }
      ]
    },
    {
      "id": "01K4D7S0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4D7S0000000000000000A03",
      "namespace": "deutsch-rechtschreibung",
      "slug": "das-dass-schreibung-ersatzprobe-dieses-jenes-welches",
      "title": "Rechtschreibdiagnose 'das' oder 'dass': Ersatzprobe (dieses/jenes/welches) vs. Konjunktion",
      "domain": "schule/deutsch/rechtschreibung",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4D7S0000000000000000A01",
          "type": "hard",
          "rationale": "Satzstrukturen und Nebensätze sind Voraussetzung für die das/dass-Unterscheidung."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q188",
          "target_label": "German orthography",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "deutsch",
          "topic_code": "lb4",
          "topic_title": "Richtig schreiben",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "deutsch",
          "topic_code": "lb4",
          "topic_title": "Richtig schreiben",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D7S0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Durch welche 3 Ersatzwörter lässt sich das Wort 'das' (mit einfachem s) ersetzen, um es zweifelsfrei von der Konjunktion 'dass' (mit Doppel-s) zu unterscheiden?",
          "concept": "dieses, jenes oder welches",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "dieses, jenes oder welches",
              "weil, obwohl oder damit"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D7S0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die grammatischen Funktionen von 'das' und 'dass' und führe die unfehlbare Ersatzprobe vor: 1. **'das' mit einfachem s**: bestimmter Artikel (*das Kind*), Demonstrativpronomen (*das weiß ich nicht* -> *dieses/jenes weiß ich nicht*) oder Relativpronomen (*das Buch, das [= welches] ich lese*), 2. **'dass' mit Doppel-s**: unterordnende Konjunktion (leitet Subjekt- oder Objektsatz ein; kann niemals durch dieses/jenes/welches ersetzt werden) und setze in folgende Sätze das/dass fehlerfrei ein: a) 'Ich hoffe, ... du ... Geschenk, ... ich dir geschickt habe, erhalten hast.' b) '... ... Wetter schön wird, ist ... Beste an diesem Tag.'",
          "concept": "das mit einfachem s: Artikel, Demonstrativ- oder Relativpronomen (Ersatzprobe: dieses/jenes/welches); dass mit Doppel-s: Konjunktion; a) 'Ich hoffe, dass [Konjunktion] du das [Artikel] Geschenk, das [Relativpronomen = welches] ich dir geschickt habe, erhalten hast.' b) 'Dass [Konjunktion] das [Artikel] Wetter schön wird, ist das [Artikel/Pronomen] Beste an diesem Tag.'",
          "sample_solution": "1. Die grammatische Differenzierung: 'das' vs. 'dass': - **1. Wann schreibt man 'das' mit einfachem s?**:   * **Als bestimmter Artikel (Begleiter des Nomens)**: Steht vor einem sächlichen Nomen (*das Fahrrad, das Haus*).   * **Als Demonstrativpronomen (hinweisendes Fürwort)**: Weist auf etwas Bestimmtes hin (*'**Das** [= dieses/jenes] habe ich schon gewusst'*).   * **Als Relativpronomen (bezügliches Fürwort)**: Leitet einen Relativsatz ein und bezieht sich auf ein vorangehendes sächliches Nomen (*'Das Auto, **das** [= welches] dort steht, ist rot'*).   * **Die unfehlbare Ersatzprobe**: Lässt sich das Wort im Satz sinnvoll durch **dieses, jenes oder welches** ersetzen, muss es **immer mit einfachem s** geschrieben werden! - **2. Wann schreibt man 'dass' mit Doppel-s?**:   * Als **unterordnende Konjunktion (Bindewort)**.   * Verbindet einen Nebensatz (meist Subjektsatz oder Objektsatz nach Verben des Wissens, Fühlens, Meinens, Hoffens) mit dem Hauptsatz (*'Ich weiß, **dass** du kommst'*, *'Er freut sich, **dass** die Ferien beginnen'*).   * Die Ersatzprobe durch *dieses/jenes/welches* funktioniert hier **niemals**! 2. Einsetzen in die Beispielsätze: - **a) 'Ich hoffe, dass [Konjunktion] du das [Artikel] Geschenk, das [Relativpronomen = welches] ich dir geschickt habe, erhalten hast.'** - **b) 'Dass [Konjunktion am Satzanfang] das [Artikel] Wetter schön wird, ist das [Artikel] Beste an diesem Tag.'**"
        }
      ]
    }
  ]
}
